import { ButtonAppearance } from '@/shared/components/buttons/ButtonConstants'
import clsx from 'clsx'
import React, { ReactNode } from 'react'

type Props = {
  id: string
  className?: string
  appearance?: ButtonAppearance
  loading?: boolean
  disabled?: boolean
  accept?: string
  multiple?: boolean
  capture?: 'user' | 'environment'
  containerClassName?: string
  onChange: React.ChangeEventHandler<HTMLInputElement>
  children: ReactNode
}

export default function FileInputButton({
  id,
  children,
  onChange,

  containerClassName = '',
  className = '',
  appearance = 'primary',
  accept,
  multiple = false,
  capture,
  disabled = false,
  loading = false,
}: Props) {
  const shouldDisable = disabled || loading

  return (
    <div className={containerClassName}>
      <label
        htmlFor={id}
        className={clsx(
          'rounded-md px-2.5 py-1.5 font-sans text-sm font-semibold text-white transition-colors',
          shouldDisable
            ? 'cursor-not-allowed bg-blue-400'
            : 'cursor-pointer bg-blue-600',
          className,
          appearance !== 'text' && 'shadow=sm',
        )}
      >
        {children}

        <input
          className="sr-only"
          id={id}
          name={id}
          type="file"
          accept={accept}
          multiple={multiple}
          capture={capture}
          disabled={shouldDisable}
          onChange={onChange}
        />
      </label>
    </div>
  )
}
